"use client";

import React from "react";
import GenericSubstantiveProcedures from "../substantive-procedures/GenericSubstantiveProcedures";

interface IASubstantiveProceduresProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Intangible Assets";

export default function IASubstantiveProcedures({ onBack, setActiveSection }: IASubstantiveProceduresProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
